import Beans3 from '@/beans';

/**  a pseudo storage used to avoid unnecessary api calls  */
/** storage can be seen as react equivalent of state */
const riperStorage = {
  args: {},
  account: null,
  cart: null,
  coupon: {
    uid: Beans3._session.get('cuid') || null,
  },
  templets: {
    'rule:bamboo:display': null,
    'rule:bamboo:display_popup_reward': null,
    'rule:bamboo:display_popup_invite': null,
    'rule:liana:display': null,
    'rule:liana:display_cart': null,
  },
  riperDisplay: null,
  onAboutBamboo: null,
  onAbout: null,
  onLogin: null,
  onRegister: null,
  onViewCart: null,
  currentPage: null,
  currencyQuery: '',
};

export default riperStorage;
